import { Route, Routes, useNavigate } from "react-router-dom";
import RestaurantRegister from "./RestaurantRegister/RestaurantRegister";
import RestaurantDetails from "./RestaurantDetails/RestaurantDetails";
import RestaurantExtraDetails from "./RestaurantExtraDetails/RestaurantExtraDetails";
import RestaurantOwnerRegister from "./RestaurantOwnerRegister/RestaurantOwnerRegister";
import RestaurantList from "./RestaurantList/RestaurantList";
import ViewRestaurant from "./ViewRestaurant/ViewRestaurant";
import IngredientList from "./IngredientList/IngredientList";
import MenuList from "./MenuList/MenuList";

const RestaurantPage = () => {
  const navigateTo = useNavigate();

  const goToStep1 = (restaurantID) => {
    navigateTo(`/restaurants/${restaurantID}/update`)
  };
  const goToStep2 = (restaurantID) => {
    navigateTo(`/restaurants/${restaurantID}/details`)
  };
  const goToStep3 = (restaurantID) => {
    navigateTo(`/restaurants/${restaurantID}/extra-details`)

  };
  const goToStep4 = (restaurantID) => {
    navigateTo(`/restaurants/${restaurantID}/owner-register`)

  };


  // #############################################################

  return (
    <>
      {/* <LocationPicker 
        open={open} 
        onClose={handleClose} 
        onSave={handleSaveLocation} 
      /> */}
      <Routes>
        <Route path="/" element={<RestaurantList />} />
        <Route path="/ingredients" element={<IngredientList />} />
        <Route path="/:restaurantID/menu" element={<MenuList />} />
        {/* <Route path="/:restaurantID/menu/:dishCode/recipe" element={<RecipeForm />} /> */}
        <Route path="/register" element={<RestaurantRegister next={goToStep2} />} />
        <Route path="/:restaurantID" element={<ViewRestaurant />} />
        <Route
          path="/:restaurantID/update"
          element={<RestaurantRegister next={goToStep2} toUpdate={goToStep1} />}
        />
        <Route
          path="/:restaurantID/details"
          element={<RestaurantDetails prev={goToStep1} next={goToStep3} />}
        />
        <Route
          path="/:restaurantID/extra-details"
          element={<RestaurantExtraDetails prev={goToStep2} next={goToStep4} />}
        />
        <Route
          path="/:restaurantID/owner-register"
          element={<RestaurantOwnerRegister prev={goToStep3} />}
        />
      </Routes>
    </>
  );
};

export default RestaurantPage;
